import { createRouter, createWebHistory } from 'vue-router';

// Componentes que serán las páginas
import HomePage from '@/views/HomePage.vue';
import AboutPage from '@/views/AboutPage.vue';
import ServicesPage from '@/views/ServicesPage.vue';
import WorksPage from '@/views/WorksPage.vue';
import ContactPage from '@/views/ContactPage.vue';
import PrivacyPolicy from '@/views/PrivacyPolicy.vue';
import TermsService from '@/views/TermsService.vue';
import CookiesPolicy from '@/views/CookiesPolicy.vue';

// Definir las rutas
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage,
  },
  {
    path: '/services',
    name: 'Services',
    component: ServicesPage,
  },
  {
    path: '/works',
    name: 'Works',
    component: WorksPage,
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage,
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
  },
  {
    path: '/terms-of-service',
    name: 'TermsService',
    component: TermsService,
  },
  {
    path: '/cookies-policy',
    name: 'CookiesPolicy',
    component: CookiesPolicy,
  },
];

// Crear instancia del router
const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        // Si hay una posición guardada (como en la navegación hacia atrás/adelante), úsala.
        return savedPosition;
      } else {
        // De lo contrario, desplázate hacia arriba.
        return { top: 0 };
      }
    },
  });

export default router;